export default "__VITE_ASSET__Ua5D2fAj__$_?nuxt_component=async&nuxt_component_name=IconFooterCarrierBring&nuxt_component_export=default__"